/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Months_Free_LabelInputs */

const zh_two_months_free_label = /** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 2 个月`)
};

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const en_two_months_free_label = () => /** @type {LocalizedString} */ ('two_months_free_label')

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const id_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const ms_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const ca_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const cs_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const da_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const de_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const et_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const es_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const fr_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const hr_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const it_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const lv_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const lt_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const hu_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const nl_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const nb_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const pl_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const pt_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const ro_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const sk_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const sl_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const fi_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const sv_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const vi_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const tr_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const el_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const bg_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const ru_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const sr_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const uk_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const ka_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const hi_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const th_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const ko_two_months_free_label = en_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const zh_tw_two_months_free_label = zh_two_months_free_label;

/** @type {(inputs: Two_Months_Free_LabelInputs) => LocalizedString} */
const ja_two_months_free_label = en_two_months_free_label;

/**

* @param {Two_Months_Free_LabelInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const two_months_free_label = /** @type {((inputs?: Two_Months_Free_LabelInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Months_Free_LabelInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_two_months_free_label(inputs)
	if (locale === "ms") return ms_two_months_free_label(inputs)
	if (locale === "ca") return ca_two_months_free_label(inputs)
	if (locale === "cs") return cs_two_months_free_label(inputs)
	if (locale === "da") return da_two_months_free_label(inputs)
	if (locale === "de") return de_two_months_free_label(inputs)
	if (locale === "et") return et_two_months_free_label(inputs)
	if (locale === "es") return es_two_months_free_label(inputs)
	if (locale === "fr") return fr_two_months_free_label(inputs)
	if (locale === "hr") return hr_two_months_free_label(inputs)
	if (locale === "it") return it_two_months_free_label(inputs)
	if (locale === "lv") return lv_two_months_free_label(inputs)
	if (locale === "lt") return lt_two_months_free_label(inputs)
	if (locale === "hu") return hu_two_months_free_label(inputs)
	if (locale === "nl") return nl_two_months_free_label(inputs)
	if (locale === "nb") return nb_two_months_free_label(inputs)
	if (locale === "pl") return pl_two_months_free_label(inputs)
	if (locale === "pt") return pt_two_months_free_label(inputs)
	if (locale === "ro") return ro_two_months_free_label(inputs)
	if (locale === "sk") return sk_two_months_free_label(inputs)
	if (locale === "sl") return sl_two_months_free_label(inputs)
	if (locale === "fi") return fi_two_months_free_label(inputs)
	if (locale === "sv") return sv_two_months_free_label(inputs)
	if (locale === "vi") return vi_two_months_free_label(inputs)
	if (locale === "tr") return tr_two_months_free_label(inputs)
	if (locale === "el") return el_two_months_free_label(inputs)
	if (locale === "bg") return bg_two_months_free_label(inputs)
	if (locale === "ru") return ru_two_months_free_label(inputs)
	if (locale === "sr") return sr_two_months_free_label(inputs)
	if (locale === "uk") return uk_two_months_free_label(inputs)
	if (locale === "ka") return ka_two_months_free_label(inputs)
	if (locale === "hi") return hi_two_months_free_label(inputs)
	if (locale === "th") return th_two_months_free_label(inputs)
	if (locale === "ko") return ko_two_months_free_label(inputs)
	if (locale === "zh") return zh_two_months_free_label(inputs)
	if (locale === "zh-tw") return zh_tw_two_months_free_label(inputs)
	if (locale === "ja") return ja_two_months_free_label(inputs)
	return en_two_months_free_label(inputs)
});